import { Palette, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { themes } from '@/themes/manifest';
import { useThemeStore } from '@/lib/theme';

export function ThemeSwitcher() {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Change theme" title="Change theme">
          <Palette className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[18rem]">
        <DropdownMenuLabel>Theme</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {themes.map((t) => (
          <DropdownMenuItem
            key={t.id}
            onClick={() => setTheme(t.id)}
            className="flex items-center gap-3"
          >
            <span
              className="inline-block h-8 w-8 rounded-(--radius-sm) border border-border flex-shrink-0"
              style={{
                background: t.preview.surface,
                borderColor: t.preview.accent,
              }}
              aria-hidden
            >
              <span
                className="block h-2 w-full rounded-t-(--radius-sm)"
                style={{ background: t.preview.accent }}
              />
            </span>
            <span className="flex-1 min-w-0">
              <span className="block font-medium text-sm leading-tight">{t.name}</span>
              <span className="block text-xs text-muted truncate">{t.description}</span>
            </span>
            {theme === t.id && <Check className="h-4 w-4 text-accent flex-shrink-0" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
